import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["service", "removeButton", "destroyField"]

  connect() {
    this.updateRemoveButtonStates()
  }

  removeService(event) {
    event.preventDefault()
    
    const serviceContainer = event.target.closest('[data-service-manager-target="service"]')
    const destroyField = serviceContainer.querySelector('[data-service-manager-target="destroyField"]')
    
    if (this.getVisibleServiceCount() <= 1) {
      // Show warning message if trying to remove last service
      this.showMinimumServiceWarning()
      return
    }
    
    // If this is an existing service (has destroy field), mark for destruction
    if (destroyField) {
      destroyField.value = '1'
      serviceContainer.style.display = 'none'
    } else {
      // For new services, just remove from DOM
      serviceContainer.remove()
    }
    
    // Update button states after removal
    this.updateRemoveButtonStates()
  }

  addService(event) {
    event.preventDefault()
    // This would be for adding new services dynamically
    // For now, Rails handles this through the build_services method
    this.updateRemoveButtonStates()
  }

  getVisibleServiceCount() {
    return this.serviceTargets.filter(service => {
      const destroyField = service.querySelector('[data-service-manager-target="destroyField"]')
      const isVisible = service.style.display !== 'none'
      const isNotDestroyed = !destroyField || destroyField.value !== '1'
      return isVisible && isNotDestroyed
    }).length
  }

  updateRemoveButtonStates() {
    const visibleServiceCount = this.getVisibleServiceCount()
    const shouldDisableRemove = visibleServiceCount <= 1
    
    this.removeButtonTargets.forEach(button => {
      const serviceContainer = button.closest('[data-service-manager-target="service"]')
      const destroyField = serviceContainer.querySelector('[data-service-manager-target="destroyField"]')
      const isVisible = serviceContainer.style.display !== 'none'
      const isNotDestroyed = !destroyField || destroyField.value !== '1'
      
      if (isVisible && isNotDestroyed) {
        if (shouldDisableRemove) {
          button.disabled = true
          button.classList.add('hidden', 'opacity-50', 'cursor-not-allowed')
          button.classList.remove('hover:text-red-800')
          button.title = 'At least one service is required'
        } else {
          button.disabled = false
          button.classList.remove('hidden', 'opacity-50', 'cursor-not-allowed')
          button.classList.add('hover:text-red-800')
          button.title = 'Remove this service'
        }
      }
    })
    
    this.updateServiceCountMessage()
  }

  updateServiceCountMessage() {
    const visibleServiceCount = this.getVisibleServiceCount()
    const messageElement = this.element.querySelector('[data-service-manager-target="countMessage"]')
    
    if (messageElement) {
      if (visibleServiceCount === 1) {
        messageElement.textContent = '1 service (minimum required)'
        messageElement.className = 'mt-2 text-sm text-blue-600'
      } else {
        messageElement.textContent = `${visibleServiceCount} services`
        messageElement.className = 'mt-2 text-sm text-gray-500'
      }
    }
  }

  showMinimumServiceWarning() {
    const messageElement = this.element.querySelector('[data-service-manager-target="countMessage"]')
    
    if (messageElement) {
      const originalText = messageElement.textContent
      const originalClass = messageElement.className
      
      messageElement.textContent = 'At least one service is required!'
      messageElement.className = 'mt-2 text-sm text-red-600'
      
      // Reset after 3 seconds
      setTimeout(() => {
        messageElement.textContent = originalText
        messageElement.className = originalClass
      }, 3000)
    }
  }
}